import React, { useState, useEffect } from "react";
import Navbar from "../../components/template/Navbar";
import Template from "../../components/template/Template";
import Cookies from "js-cookie";
import { AxiosCustomGet } from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import { useHistory } from "react-router-dom";
import AppRoutePath from "../../router/AppRoutePath";
import { Button } from "antd";
import { MdSave } from "react-icons/md";
import { AxiosCustomPost } from "../../components/axios/AxiosCustom";

function AddRole(props) {
  const [groupedActions, setGroupedActions] = useState([]);
  const [groupedPermissions, setGroupedPermissions] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [name, setName] = useState();
  const [loginType, setLoginType] = useState({});
  const [actions, setActions] = useState({});
  const history = useHistory();

  useEffect(() => {
    getGroupedActions();
    getActions();
  }, []);

  const getGroupedActions = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}permissions/groupedActions`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        // console.log("grouped action ", response.data.data);
        setGroupedActions(response.data.data);
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getActions = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}permissions/actions`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setActions(response.data.data);
      }
    );
  };

  const getGroupedPermissions = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}permissions/myPermissionsGrouped`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        // console.log("grouped action ", response.data.data);
        setGroupedPermissions(response.data.data);
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleCheckbox = (e) => {
    let { name, checked } = e.target;
    setPermissions((prev) => ({
      ...prev,
      [name]: checked,
    }));
    if (
      name == "view_pick_up_gadai" ||
      name == "view_sheduled_pick_up_gadai" ||
      name == "view_delivery_gadai" ||
      name == "view_scheduled_delivery_gadai" ||
      name == "view_history_delivery_gadai" ||
      name == "view_area"
    ) {
      setPermissions((prev) => ({
        ...prev,
        view_employee: true,
      }));
    }
  };

  const addRole = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}role`;
    let data = {
      name,
      permissions: !loginType.login_web ? {} : permissions,
      description: " ",
      login_permissions: loginType,
    };
    // console.log(permissions);
    if (name === undefined || name === "") {
      SwalToast.fire({
        icon: "error",
        title: "Nama Role Belum diisi",
      });
    } else {
      console.log(data);
      AxiosCustomPost(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        (response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          history.push(AppRoutePath.ROLE);
        },
        (error) => {
          console.log(error);
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: error.response.data,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        }
      );
    }
  };

  const handleChangeLoginType = (e) => {
    const { name, checked } = e.target;
    setLoginType((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      for (let i = 0; i < actions.length; i++) {
        let actionTemp = actions[i];
        setPermissions((prev) => ({
          ...prev,
          [actionTemp]: true,
        }));
      }
    } else {
      setPermissions({});
    }
  };

  return (
    <div>
      <div style={{ padding: 24 }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: "#303030" }}>
          Tambah Role
        </div>
        <div
          style={{
            marginTop: 30,
            padding: 20,
            boxShadow: "0px 4px 12px rgba(54, 53, 53, 0.12)",
            borderRadius: 10,
          }}
        >
          <div style={{ fontWeight: 600 }}>Tambah Role</div>
          <div style={{ marginTop: 24 }}>
            <div style={{ color: "#A6A6A6" }}>Nama Role</div>
            <input
              type="text"
              className="form-control border-DCDCDC mt-1"
              required
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div style={{ marginTop: 24 }}>
            <div style={{ color: "#A6A6A6", marginBottom: 10 }}>Login Type</div>
            <div style={{ margin: "20px 0 0 0" }}>
              <div style={{ display: "flex", width: "50%" }}>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    name="login_front_office"
                    style={{ accentColor: "#fa6629", width: 15, height: 15 }}
                    type="checkbox"
                    onChange={handleChangeLoginType}
                  />
                  <p style={{ margin: "0px 0px 0px 10px" }}>Front Office</p>
                </div>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    name="login_valuator"
                    style={{ accentColor: "#fa6629", width: 15, height: 15 }}
                    type="checkbox"
                    onChange={handleChangeLoginType}
                  />
                  <p style={{ margin: "0px 0px 0px 10px" }}>Valuator</p>
                </div>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    name="login_web"
                    style={{ accentColor: "#fa6629", width: 15, height: 15 }}
                    type="checkbox"
                    onChange={handleChangeLoginType}
                  />
                  <p style={{ margin: "0px 0px 0px 10px" }}>Web</p>
                </div>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 24 }}>
            <div style={{ color: "#A6A6A6", marginBottom: 10 }}>Role Akses</div>
            <input
              style={styles.checkbox}
              type="checkbox"
              onClick={handleCheckAll}
            />{" "}
            Pilih Semua
          </div>

          <div style={{ margin: "20px 0 0 -10px" }}>
            <div style={{ display: "flex", width: "90%" }}>
              <div style={{ flex: 1.8 }} />
              <div style={{ flex: 0.5 }}>Lihat</div>
              <div style={{ flex: 0.5 }}>Tambah</div>
              <div style={{ flex: 0.5 }}>Ubah</div>
              <div style={{ flex: 0.5 }}>Hapus</div>
              <div style={{ flex: 0.5 }}>Print</div>
            </div>
          </div>
          <div style={{ margin: "20px 0 0 -10px" }}>
            <div style={{ width: "90%", display: "flex" }}>
              <br />
              <div style={{ flex: 1.8 }}>
                {groupedActions?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        padding: "10px",
                        backgroundColor: index % 2 === 1 && "#F5F5F5",
                      }}
                    >
                      <div style={{ flex: 1 }}>{item.name}</div>
                    </div>
                  );
                })}
              </div>

              <div style={{ flex: 2.5 }}>
                {groupedActions.map((element, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        padding: "10px 0",
                        backgroundColor: index % 2 === 1 && "#F5F5F5",
                      }}
                    >
                      {element.actions.some((v) => v.includes("view")) ? (
                        element.actions.map((el, index2) => {
                          return (
                            <>
                              {el.includes("view") ? (
                                <div key={index2} style={{ flex: 1 }}>
                                  <input
                                    disabled={!loginType.login_web}
                                    checked={
                                      !loginType.login_web
                                        ? false
                                        : permissions[el]
                                    }
                                    name={el}
                                    onChange={(e) => handleCheckbox(e)}
                                    style={{
                                      accentColor: "#fa6629",
                                    }}
                                    type="checkbox"
                                  />
                                </div>
                              ) : null}
                            </>
                          );
                        })
                      ) : (
                        <div style={{ flex: 1 }} />
                      )}

                      {element.actions.some((v) => v.includes("create")) ? (
                        element.actions.map((el, index2) => {
                          return (
                            <>
                              {el.includes("create") ? (
                                <div key={index2} style={{ flex: 1 }}>
                                  <input
                                    disabled={!loginType.login_web}
                                    checked={
                                      !loginType.login_web
                                        ? false
                                        : permissions[el]
                                    }
                                    name={el}
                                    onChange={(e) => handleCheckbox(e)}
                                    style={{
                                      accentColor: "#fa6629",
                                    }}
                                    type="checkbox"
                                  />
                                </div>
                              ) : null}
                            </>
                          );
                        })
                      ) : (
                        <div style={{ flex: 1 }} />
                      )}

                      {element.actions.some((v) => v.includes("update")) ? (
                        element.actions.map((el, index2) => {
                          return (
                            <>
                              {el.includes("update") ? (
                                <div key={index2} style={{ flex: 1 }}>
                                  <input
                                    disabled={!loginType.login_web}
                                    checked={
                                      !loginType.login_web
                                        ? false
                                        : permissions[el]
                                    }
                                    name={el}
                                    onChange={(e) => handleCheckbox(e)}
                                    style={{
                                      accentColor: "#fa6629",
                                    }}
                                    type="checkbox"
                                  />
                                </div>
                              ) : null}
                            </>
                          );
                        })
                      ) : (
                        <div style={{ flex: 1 }} />
                      )}

                      {element.actions.some((v) => v.includes("delete")) ? (
                        element.actions.map((el, index2) => {
                          return (
                            <>
                              {el.includes("delete") ? (
                                <div key={index2} style={{ flex: 1 }}>
                                  <input
                                    disabled={!loginType.login_web}
                                    checked={
                                      !loginType.login_web
                                        ? false
                                        : permissions[el]
                                    }
                                    name={el}
                                    onChange={(e) => handleCheckbox(e)}
                                    style={{
                                      accentColor: "#fa6629",
                                    }}
                                    type="checkbox"
                                  />
                                </div>
                              ) : null}
                            </>
                          );
                        })
                      ) : (
                        <div style={{ flex: 1 }} />
                      )}

                      {element.actions.some((v) => v.includes("print")) ? (
                        element.actions.map((el, index2) => {
                          return (
                            <>
                              {el.includes("print") ? (
                                <div key={index2} style={{ flex: 1 }}>
                                  <input
                                    disabled={!loginType.login_web}
                                    checked={
                                      !loginType.login_web
                                        ? false
                                        : permissions[el]
                                    }
                                    name={el}
                                    onChange={(e) => handleCheckbox(e)}
                                    style={{
                                      accentColor: "#fa6629",
                                    }}
                                    type="checkbox"
                                  />
                                </div>
                              ) : null}
                            </>
                          );
                        })
                      ) : (
                        <div style={{ flex: 1 }} />
                      )}
                      {/* {element.actions.map((el, index2) => {
                        return (
                          <>
                            {element.actions.some((v) => v.includes("view")) ? (
                              <div style={{ flex: 1 }}>
                                <input
                                  name={el}
                                  onChange={(e) => handleCheckbox(e)}
                                  style={{
                                    accentColor: "#fa6629",
                                  }}
                                  type="checkbox"
                                />
                              </div>
                            ) : (
                              <div style={{ flex: 1 }} />
                            )}
                            {element.actions.includes(el.includes("create")) ? (
                              <div style={{ flex: 1 }}>
                                <input
                                  name={el}
                                  onChange={(e) => handleCheckbox(e)}
                                  style={{
                                    accentColor: "#fa6629",
                                  }}
                                  type="checkbox"
                                />
                              </div>
                            ) : (
                              <div style={{ flex: 1 }} />
                            )}
                            {element.actions.includes(el.includes("update")) ? (
                              <div style={{ flex: 1 }}>
                                <input
                                  name={el}
                                  onChange={(e) => handleCheckbox(e)}
                                  style={{
                                    accentColor: "#fa6629",
                                  }}
                                  type="checkbox"
                                />
                              </div>
                            ) : (
                              <div style={{ flex: 1 }} />
                            )}
                            {element.actions.includes(el.includes("delete")) ? (
                              <div style={{ flex: 1 }}>
                                <input
                                  name={el}
                                  onChange={(e) => handleCheckbox(e)}
                                  style={{
                                    accentColor: "#fa6629",
                                  }}
                                  type="checkbox"
                                />
                              </div>
                            ) : (
                              <div style={{ flex: 1 }} />
                            )}
                            {element.actions.includes(el.includes("print")) ? (
                              <div style={{ flex: 1 }}>
                                <input
                                  name={el}
                                  onChange={(e) => handleCheckbox(e)}
                                  style={{
                                    accentColor: "#fa6629",
                                  }}
                                  type="checkbox"
                                />
                              </div>
                            ) : (
                              <div style={{ flex: 1 }} />
                            )}
                          </>
                        );
                      })} */}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-end", margin: 20 }}
        >
          <Button
            onClick={() => history.goBack()}
            style={{
              margin: 5,
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>
          <Button
            type="submit"
            disabled={submitting}
            onClick={() => addRole()}
            style={{
              margin: 5,
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            <MdSave style={{ fontSize: 20, marginRight: 5 }} />
            Simpan
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AddRole;

const styles = {
  checkbox: {
    accentColor: "#fa6629",
    width: 15,
    height: 15,
  },
};
